import { render, staticRenderFns } from "./DmcaTakedownPolicy.vue?vue&type=template&id=78cc2330&"
import script from "./DmcaTakedownPolicy.vue?vue&type=script&lang=js&"
export * from "./DmcaTakedownPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports